import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-sales-order-detail',
  standalone: false,
  
  templateUrl: './daily-sales-order-detail.component.html',
  styles: ``
})
export class DailySalesOrderDetailComponent {

}
